import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: (containerAttributes) => ({
    display: 'flex',
    height: containerAttributes.containerheight,
    justifyContent: 'center',
    alignItems: 'center',
  }),
}));

const LoaderElement = withStyles({
  root: (attributes) => ({
    color: attributes.strokecolor,
    height: attributes.size,
    width: attributes.size,
  }),
})(CircularProgress);

const WELoader = (props) => {
  const attributes = { ...props };
  if (!attributes.strokecolor) {
    attributes.strokecolor = '#324DF5';
  }
  if (!attributes.size) {
    attributes.size = '5rem';
  }
  if (!attributes.heightoffset) {
    attributes.heightoffset = 0;
  }
  attributes.containerheight = 100 - attributes.heightoffset + 'vh';

  const classes = useStyles({ containerheight: attributes.containerheight });

  return (
    <Typography component="div" className={classes.root} {...attributes}>
      <LoaderElement {...attributes} />
    </Typography>
  );
};

export default WELoader;
